/** @jsxImportSource theme-ui */
import { useField } from 'formik';
import React from 'react';

import { BdDropdown } from 'components/_controls/BdDropdown/BdDropdown';

import { SemanticFormikDdlProps, SemanticFormikProps } from './FormikSemanticProps';

export const FormikSemanticDropDown: React.FC<SemanticFormikProps & SemanticFormikDdlProps> = ({
  name,
  placeholder,
  options,
  error,
  disabled,
  fluid,
  onValueChange,
  ...props
}) => {
  const [field, , helpers] = useField(name);
  const { setValue, setTouched } = helpers;
  const { value } = field;

  const handleOnChange = (value: string | number | boolean | (string | number | boolean)[]) => {
    setValue(value);
    onValueChange && onValueChange(value);
  };

  return (
    <BdDropdown
      placeholder={placeholder}
      options={options}
      value={value}
      error={error}
      onChange={handleOnChange}
      onBlur={setTouched}
      disabled={disabled}
      fluid={fluid}
      {...props}
    />
  );
};
